import { Modal } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { callProvince } from "../../../../components/address/address.logic";
import {
    createFieldInput,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../utils/form";
import { defineAsyncComponent } from "vue";
import { callUser } from "./requestor/requestor.section";
import { dateFormat } from "../../../../utils/date";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const callRequestType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_TYPE", value: searchQuery });
export const callStorageLocationAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "STORAGE_LOCATION_ATTACHMENT", value: searchQuery })
        .then(d => lodash.orderBy(d, ['attribute.isRequiredAttachment', 'seq'], ['desc', 'asc']));

export const callManufactureLocationAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "MANUFACTURE_LOCATION_ATTACHMENT", value: searchQuery })
        .then(d => lodash.orderBy(d, ['attribute.isRequiredAttachment', 'seq'], ['desc', 'asc']));
export const callRequestDoc = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", value: searchQuery });
export const callRequestStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_STATUS", value: searchQuery });
export const callStorageLocation = ({ searchQuery, isLocation, userInfo, isOfficerCreate, expireDate, requestTypeKey }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "isLocation", type: "Boolean", operator: "=", value: isLocation },
        // { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") }
    ];

    if (requestTypeKey === "3") {
        where.push({ name: "expireDate", type: "Date", operator: "<=", value: expireDate ? expireDate : moment().add(3, "months").format("YYYY-MM-DD") })
        where.push({ openBucket: true, name: "isRenewed", type: "Boolean", operator: "=", value: false })
        where.push({ closeBucket: true, logic: "OR", name: "isRenewed", type: "Boolean", operator: "=", value: null })
    } else {
        where.push({ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") })
    }

    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "refUserCompany.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "refUserCompany.id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (expireDate) {
        where.push({ name: "expireDate", type: "Date", operator: "<=", value: expireDate });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }

    return store
        .dispatch("resource/v1/transaction/storageLocation/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh", "expireDate"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callStorageLocationFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/storageLocation/search", {
            criteria: {
                select: ["**", "refUserCompany.refPersonType.*", "refUser.refPersonType.*"],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "addresses",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    { name: "attachments", select: ["**"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
                    { name: "subs", select: ["*", "refType.*"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
                    { name: "experts", select: ["*"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
                    { name: "types", select: ["*", "refLocationType.*"], page: 0, size: 1000000 },
                    { name: "productTypes", select: ["*", "refLocationProductType.*"], page: 0, size: 1000000 },
                    {
                        name: "refUserCompany.addresses",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};

export const createColumns = ({ props }) => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.storageLocation.refUserCompany"),
            dataIndex: "refStorageLocationTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refStorageLocationTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refStorageLocationTemp?.refUserCompany?.companyNameTh
                    : record.refStorageLocationTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refStorageLocation.approveCode",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.storageLocation.expireDate"),
            dataIndex: "refStorageLocation.expireDate",
            align: "center"
        }),
        createColumnInput({
            title: () =>
                props.isLocation ? i18n.global.t("model.storageLocation.isLocation") : i18n.global.t("views.request.manufactureLocation.title"),
            dataIndex: "refStorageLocationTemp.name"
        }),
        createColumnSelect({
            title: () =>
                props.isLocation
                    ? i18n.global.t("views.request.storageLocation.province")
                    : i18n.global.t("views.request.manufactureLocation.province"),
            dataIndex: "refStorageLocationTemp.addresses.refProvince.nameTh",
            dataIndexValue: ({ record }) => record.refStorageLocationTemp?.addresses?.[0]?.refProvince?.nameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: callProvince, optLabel: "nameTh" }),
            search: { name: "refStorageLocationTemp.addresses.refProvince.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, refs, key }) => {
    const { viewOnly, isLocation } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refStorageLocation
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("model.request.refRequestType") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1", "3"].includes(value?.key)) {
                                                const { createForm } = require("./request.logic");
                                                cloneStorageLocation({
                                                    data,
                                                    model: {
                                                        ...createForm({ props, data, refs }),
                                                        id: model.id,
                                                        version: model.version,
                                                        isActive: model.isActive,
                                                        refStatus: model.refStatus,
                                                        refRequestDoc: model.refRequestDoc,
                                                        draftCode: model.draftCode,
                                                        requestCode: model.requestCode
                                                    }
                                                });
                                            } else {
                                                cloneStorageLocation({ data, model, id: model.refStorageLocation?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: callRequestType,
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refStorageLocation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.storageLocation.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refStorageLocation,
                            "onUpdate:value": value => {
                                const oldValue = model.refStorageLocation;
                                model.refStorageLocation = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneStorageLocation({ data, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refStorageLocation = oldValue;
                                        }
                                    });
                                } else {
                                    cloneStorageLocation({ data, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callStorageLocation({
                                    searchQuery,
                                    isLocation,
                                    userInfo: store.state.resource.auth.info?.user,
                                    isOfficerCreate: model.isOfficerCreate,
                                    requestDocKey: model.refRequestDoc?.key,
                                    requestTypeKey: model.refRequestType?.key,
                                    expireDate:
                                        model.refRequestDoc?.key && model.refRequestType?.key === "3"
                                            ? moment()
                                                  .add(model.refRequestDoc.attribute.renew, model.refRequestDoc.attribute.renewUnit)
                                                  .format("YYYY-MM-DD")
                                            : null
                                }).then((res) => {
                                    // loop for check disabled item
                                    if (model.refRequestType?.key === "3") {
                                        res.forEach(d => d.disabled = d.expireDate && moment(moment().format("YYYY-MM-DD")).isAfter(moment(d.expireDate)));
                                    }
                                    return res;
                                }),
                            renderLabel: ({ item }) => {
                                const expire = item.expireDate ? ` (Expire: ${dateFormat({ text: item.expireDate, format: "DD/MM/YYYY"})})` : ''
                                return <div>{item.approveCode}{expire} - {item.refUserCompany?.fullNameTh}</div>
                            },
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => (model.refStorageLocationNew?.approveCode && model.refStorageLocationNew?.expireDate) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refStorageLocationNew.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.storageLocation.info.approveCodeNew")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: `${model.refStorageLocationNew.approveCode} (ExpireDate: ${dateFormat({ text: model.refStorageLocationNew.expireDate, format: "DD/MM/YYYY" })})`,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly || model.isOfficerCreate
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forReceiveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forReceiveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forReceiveRemark[0].remark = value),
                            disabled: viewOnly || model.isOfficerCreate
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const cloneStorageLocation = ({ data, model, id }) => {
    if (id) {
        setIsLoadingApp(true);
        callStorageLocationFull({ id })
            .then(storageLocation => {
                const refStorageLocationTemp = copyForm({ form: { ...storageLocation, isTemp: true } });
                if (id) {
                    refStorageLocationTemp.addresses.forEach((d, index) => (d.refRealId = storageLocation.addresses[index].id));
                    refStorageLocationTemp.attachments.forEach((d, index) => (d.refRealId = storageLocation.attachments[index].id));
                    refStorageLocationTemp.subs.forEach((d, index) => (d.refReal = { id: storageLocation.subs[index].id }));
                    refStorageLocationTemp.experts.forEach((d, index) => (d.refReal = { id: storageLocation.experts[index].id }));
                    refStorageLocationTemp.types.forEach((d, index) => (d.refReal = { id: storageLocation.types[index].id }));
                    refStorageLocationTemp.productTypes.forEach((d, index) => (d.refReal = { id: storageLocation.productTypes[index].id }));
                }
                return callUser({ userCompanyId: refStorageLocationTemp.refUserCompany.id }).then(users => {
                    refStorageLocationTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id) || refStorageLocationTemp.refUser;
                    router.push({
                        name: router.currentRoute.value.name,
                        params: {
                            props: JSON.stringify({
                                form: {
                                    ...model,
                                    refRequestDoc: getRequestDoc({ data, isLocation: refStorageLocationTemp.isLocation }),
                                    refDepartment: storageLocation.refDepartment,
                                    refStorageLocationTemp
                                }
                            })
                        },
                        query: { _timestamp: new Date().getTime() }
                    });
                });
            })
            .finally(() => setIsLoadingApp(false));
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

const getRequestDoc = ({ data, isLocation }) => {
    return data.requestDocs.find(d => d.key === (isLocation ? "06" : "07"));
};
